import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      // Show CTA bar after scrolling 50% of viewport height
      const scrolled = window.scrollY;
      const threshold = window.innerHeight * 0.5;
      
      if (scrolled > threshold && !isDismissed) {
        setIsVisible(true);
      } else if (scrolled <= threshold) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-grandpal-green text-white shadow-lg border-t">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium">
              Need expert advice? 
              <span className="hidden sm:inline"> Book a call with an expert for personalized guidance.</span>
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button 
              size="sm"
              variant="secondary"
              className="bg-white text-grandpal-green hover:bg-gray-100 font-semibold"
              onClick={() => navigate('/consultations')}
            >
              Book Call
            </Button>
            <button 
              onClick={handleDismiss}
              className="text-white hover:text-gray-200 transition-colors"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}